(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cst-nav-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var wrapper = header.querySelector('.nav-wrapper');
    var navFull = header.querySelector('.nav-grid--full');
    var navCompact = header.querySelector('.nav-grid--compact');
    var fullH = 0;
    var compactH = 0;

    function isMobile() {
      return window.innerWidth <= 767;
    }

    if (wrapper && navFull && navCompact) {
      fullH = navFull.offsetHeight;
      compactH = navCompact.offsetHeight;
      if (!isMobile()) {
        wrapper.style.height = fullH + 'px';
      }
    }

    function updateScrollState() {
      var scrolled = window.scrollY > 0;
      header.classList.toggle('scrolled', scrolled);

      if (wrapper && navFull && navCompact && !isMobile()) {
        wrapper.style.height = (scrolled ? compactH : fullH) + 'px';
        navFull.toggleAttribute('inert', scrolled);
        navFull.setAttribute('aria-hidden', String(scrolled));
        navCompact.toggleAttribute('inert', !scrolled);
        navCompact.setAttribute('aria-hidden', String(!scrolled));
      }
    }

    header.style.transition = 'none';
    if (wrapper) wrapper.style.transition = 'none';
    if (navFull) navFull.style.transition = 'none';
    if (navCompact) navCompact.style.transition = 'none';

    updateScrollState();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        header.style.transition = '';
        if (wrapper) wrapper.style.transition = '';
        if (navFull) navFull.style.transition = '';
        if (navCompact) navCompact.style.transition = '';
      });
    });

    window.addEventListener('scroll', updateScrollState, { passive: true });

    // Mobile drawer toggle
    var toggle = header.querySelector('.site-header__menu-toggle');
    var section = header.parentElement;
    var drawer = section ? section.querySelector('.nav-drawer') : null;
    var overlay = section ? section.querySelector('.nav-drawer-overlay') : null;
    var closeBtn = drawer ? drawer.querySelector('.nav-drawer__close') : null;

    function openDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }

    if (toggle) toggle.addEventListener('click', openDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (drawer) {
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });
    }

    // Dropdown keyboard: aria-expanded + Escape to close
    header.querySelectorAll('.dropdown').forEach(function (dropdown) {
      var trigger = dropdown.querySelector('[aria-haspopup]');
      if (!trigger) return;

      dropdown.addEventListener('focusin', function () {
        trigger.setAttribute('aria-expanded', 'true');
      });

      dropdown.addEventListener('focusout', function (e) {
        if (!dropdown.contains(e.relatedTarget)) {
          trigger.setAttribute('aria-expanded', 'false'); 
        }
      });

      dropdown.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });
    });
  })();
  document.querySelectorAll('.nav-drawer__toggle').forEach((button) => {
    button.addEventListener('click', () => {
      const parent = button.closest('.nav-drawer__item');
      parent.classList.toggle('active');
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', !expanded);
    });
  });
  // function updateCartCount() {
  //   fetch('/cart.js')
  //     .then(response => response.json())
  //     .then(cart => {

  //       document.querySelectorAll('.js-cart-count').forEach(countEl => {
  //         countEl.textContent = cart.item_count;

  //         if (cart.item_count > 0) {
  //           countEl.style.display = 'flex';
  //         } else {
  //           countEl.style.display = 'none';
  //         }
  //       });

  //       document.querySelectorAll('.js-cart-button').forEach(btn => {
  //         btn.setAttribute(
  //           'aria-label',
  //           `Cart (${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'})`
  //         );
  //       });

  //     });
  // }

  window.updateCartCount = function() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        document.querySelectorAll('.js-cart-count').forEach(countEl => {
          countEl.textContent = cart.item_count;
          if (cart.item_count > 0) {
            countEl.style.display = 'flex';
          } else {
            countEl.style.display = 'none';
          }
        });
      });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cst-pick-a-card"] && !Shopify.designMode) return;
  try {
    
class CstPickACard {
  constructor(el) {
    this.el          = el;
    this.dialog      = el.querySelector('.cst-pac__dialog');
    this.frontImg    = el.querySelector('.cst-pac__dialog-img--front');
    this.backImg     = el.querySelector('.cst-pac__dialog-img--back');
    this.backFig     = el.querySelector('.cst-pac__dialog-figure--back');
    this.frontLink   = el.querySelector('.cst-pac__dialog-img-link--front');
    this.backLink    = el.querySelector('.cst-pac__dialog-img-link--back');
    this._hoverTimer = null;
    this._activeLink = null;

    this.bindEvents();
  }

  bindEvents() {
    var self = this;

    this.el.querySelectorAll('.cst-pac__card-btn').forEach(function (btn) {
      btn.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        self._activeLink = btn;
        self._hoverTimer = setTimeout(function () {
          self.openDialog(btn);
        }, 200);
      });

      btn.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(self._hoverTimer);
        self._hoverTimer = null;
      });
    });

    // Clicking the ::backdrop (the <dialog> element itself, outside .cst-pac__dialog-inner)
    this.dialog.addEventListener('click', function (e) {
      if (e.target === self.dialog) self.dialog.close();
    });

    // Close when the mouse leaves the dialog bounds
    this.dialog.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      self.dialog.close();
    });

    // 'close' fires after both Esc (native) and dialog.close() — single cleanup path
    this.dialog.addEventListener('close', function () {
      self.dialog.style.margin = '';
      self.dialog.style.left   = '';
      self.dialog.style.top    = '';
      if (self._activeLink) {
        self._activeLink.focus();
        self._activeLink = null;
      }
      self.frontImg.src         = '';
      self.frontImg.style.width = '';
      self.backImg.src          = '';
      self.backImg.style.width  = '';
    });
  }

  openDialog(link) {
    var cardRect = link.getBoundingClientRect();
    this.frontImg.style.width = cardRect.width + 'px';
    this.backImg.style.width  = cardRect.width + 'px';

    this.frontImg.src   = link.dataset.front || '';
    this.frontImg.alt   = link.dataset.frontAlt || '';
    this.frontLink.href = link.href;
    this.backLink.href  = link.href;

    var back = link.dataset.back || '';
    if (back) {
      this.backImg.src = back;
      this.backImg.alt = link.dataset.backAlt || '';
      this.backFig.removeAttribute('hidden');
    } else {
      this.backImg.src = '';
      this.backImg.alt = '';
      this.backFig.setAttribute('hidden', '');
    }

    if (!this.dialog.open) {
      // Suppress UA auto-centering before showModal so we can position manually
      this.dialog.style.margin = '0';
      this.dialog.showModal();
    }

    this.positionOver(link);
  }

  positionOver(link) {
    var card  = link.getBoundingClientRect();
    var dlg   = this.dialog.getBoundingClientRect();
    var ipad  = 12; // matches .cst-pac__dialog-inner padding
    var edge  = 8;

    // Align the dialog so its inner padding puts the front image exactly over the card
    var left = card.left - ipad;
    var top  = card.top  - ipad;

    // If the dialog bleeds off the right edge of the viewport, shift it left
    if (left + dlg.width + edge > window.innerWidth) {
      left = window.innerWidth - dlg.width - edge;
    }
    left = Math.max(edge, left);

    // Clamp vertically
    top = Math.max(edge, Math.min(top, window.innerHeight - dlg.height - edge));

    this.dialog.style.left = left + 'px';
    this.dialog.style.top  = top  + 'px';
  }
}

document.querySelectorAll('.cst-pac').forEach(function (el) {
  new CstPickACard(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cst-product-carousel"] && !Shopify.designMode) return;
  try {
    
class CstProductCarousel {
  constructor(el) {
    this.trackWrap = el.querySelector('.cst-pcc__track-wrap');
    this.prevBtn   = el.querySelector('.cst-pcc__arrow--prev');
    this.nextBtn   = el.querySelector('.cst-pcc__arrow--next');

    this.prevBtn.addEventListener('click', this.prev.bind(this));
    this.nextBtn.addEventListener('click', this.next.bind(this));
    this.trackWrap.addEventListener('scroll', this.updateButtons.bind(this), { passive: true });

    this.updateButtons();
  }

  prev() {
    this.trackWrap.scrollBy({ left: -this.trackWrap.clientWidth, behavior: 'smooth' });
  }

  next() {
    this.trackWrap.scrollBy({ left: this.trackWrap.clientWidth, behavior: 'smooth' });
  }

  updateButtons() {
    var sl  = Math.round(this.trackWrap.scrollLeft);
    var max = this.trackWrap.scrollWidth - this.trackWrap.clientWidth;
    this.prevBtn.disabled = sl <= 0;
    this.nextBtn.disabled = sl >= max;
  }
}

document.querySelectorAll('.cst-pcc').forEach(function (el) {
  new CstProductCarousel(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cst-wins-losses"] && !Shopify.designMode) return;
  try {
    
  //slider js
  document.querySelectorAll('.cst-compare-slider').forEach((slider) => {
    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
